<div *ngIf="aiReportError">
  <p class="fs-14 mb-0">
    {{ aiReportError }}
  </p>
</div>
